import React from 'react';
import MOTKGAMETITLE from '../Assets/Images/Title.png';
import logo from '../Assets/Images/ObesquitoLogo.png';
import DropDownMenu from '../Component/Menudropdown';
import { useText } from '../Content/SiteContentContext';
import PageBlocks from '../Content/PageBlocks';

function MOTKPAGE(): JSX.Element {
  return (
    <div className="MOTK">
      <div style={{ width: '100%', height: '50px', display: 'flex' }} className="menuBar">
        <div>
          <img src={logo} className="background-Image" alt="Obesquito" />
        </div>
        <div>
          <DropDownMenu />
        </div>
      </div>
      <div style={{ width: '100%' }}>
        <div className="section-Border">
          <div style={{ height: '500px' }}>
            <img
              src={MOTKGAMETITLE}
              className="background-Image"
              alt="MOTK Game Title"
              style={{ height: '500px', aspectRatio: '5 / 1' }}
            />
          </div>
        </div>
        <div className="section-Border">
          <div>
            <h1 style={{ textAlign: 'right' }}>{useText('motk.point1.title')}</h1>
            <p style={{ textAlign: 'right' }}>{useText('motk.point1.body')}</p>
          </div>
          <div>
            <h1 style={{ textAlign: 'left' }}>{useText('motk.point2.title')}</h1>
            <p style={{ textAlign: 'left' }}>{useText('motk.point2.body')}</p>
          </div>
          <div>
            <h1 style={{ textAlign: 'right' }}>{useText('motk.point3.title')}</h1>
            <p style={{ textAlign: 'right' }}>{useText('motk.point3.body')}</p>
          </div>
        </div>
        <div className="section-Border">
          {/* Admin-managed paragraphs (admin center > Page sections). */}
          <PageBlocks page="Mark of the Knights" />
        </div>
      </div>
    </div>
  );
}

export default MOTKPAGE;
